import { formURL } from "Utils/CommonUtilities";
import BaseApiRequest from "./BaseApiRequest";
import { GET_ACCOUNT_DATA } from "../ApiUrls";
import { METHOD } from "../Constants";

export default class GetAccountDataRequest extends BaseApiRequest {
  method = METHOD.HTTP.GET;

  body = {};

  url = GET_ACCOUNT_DATA;

  constructor(accountId) {
    super();
    const paramList = [accountId];
    this.url = formURL(this.url, paramList);
  }

  getMethod = () => this.method;

  getUrl = () => this.url;

  getBody = () => this.body;
}
